import moment from 'moment';
import {BaseFormService} from "@services/base-form.service";

export class DateValidationMixin extends BaseFormService {
  dataEmissaoInicio: any;
  dataEmissaoFim: any;

  dataInicialError = false;
  dataFinalError = false;
  dataInicialMessageError = 'Data Inicial Inválida';
  dataFinalMessageError = 'Data Final Inválida';
  dataInicialVazia = false;
  dataFinalVazia = false;
  dataAtual: string;

  dataHoje(): void {
    const data = new Date();
    this.dataAtual = `${data.getFullYear()}-${data.getMonth() + 1}-${data.getDate()}`;

    if (this.dataEmissaoInicio && moment(this.dataEmissaoInicio) > moment(this.dataAtual)) {
      this.dataInicialError = true;
      this.dataInicialMessageError = 'Data Inicial Inválida';
    }

    if (this.dataEmissaoFim && moment(this.dataEmissaoFim) > moment(this.dataAtual)) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Data Final Inválida';
    }

    if (!this.dataEmissaoInicio || !this.dataEmissaoFim) {
      this.dataFinalError = false;
      this.dataInicialError = false;
    }
  }

  onDataInicialPedido(): void {
    if (!this.dataEmissaoInicio) {
      this.dataInicialError = true;
      this.dataInicialMessageError = '';
      return;
    }
    if (this.dataEmissaoFim && moment(this.dataEmissaoInicio) > moment(this.dataEmissaoFim)) {
      this.dataInicialError = true;
      this.dataInicialMessageError = 'Data Inicial Maior que Data Final';
    } else {
      this.dataInicialError = false;
      this.dataInicialMessageError = 'Data Inicial Inválida';
    }
  }

  onDataFinalPedido(): void {
    if (!this.dataEmissaoFim) {
      this.dataFinalError = true;
      this.dataFinalMessageError = '';
      return;
    }
    if (this.dataEmissaoInicio && moment(this.dataEmissaoInicio) > moment(this.dataEmissaoFim)) {
      this.dataFinalError = true;
      this.dataFinalMessageError = 'Data Final Menor que Data Inicial';
    } else {
      this.dataFinalError = false;
      this.dataFinalMessageError = 'Data Final Inválida';
    }
  }

  filtrarData(): void {
    this.dataInicialVazia = !this.dataEmissaoInicio;
    this.dataFinalVazia = !this.dataEmissaoFim;
  }

  avisoData(): void {
    this.filtrarData();
    this.onDataFinalPedido();
    this.onDataInicialPedido();
  }
}
